import React from "react";
import PageTitle from "../Dashboard/PageTitle";
import "../Dashboard/main.css";
import LongtermTradesContainer from "./LongtermTradesContainer";

function TradeTrackmain() {
  return (
    <main id="main" className="main">
      <PageTitle page={"TradeTrack"} />
      <LongtermTradesContainer/>
    </main>
  );
}

export default TradeTrackmain;
